<template #content>
    <section v-if="isLoading" class="p-5 d-flex flex-column text-center text-primary">
        <i class="fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite"></i>
        <span class="mt-1">
            <b>Loading...</b>
        </span>
    </section>
    <section v-if="!isLoading && eligibilityData?.Request_Validation?.yes_no_response_code" class="error-modal p-4">
        <div class="error-container">
            <h6 class="sub-text">Server Error: {{ eligibilityData?.Request_Validation?.reject_reason_code }}</h6>
            <h6 class="sub-text">{{ eligibilityData?.Request_Validation?.follow_up_action_code }}</h6>
        </div>
        <div class="d-flex justify-content-center mt-3">
            <button class="btn btn-primary btn-sm" @click="cancel()">Close</button>
        </div>
    </section>

    <section v-if="!isLoading && !eligibilityData?.Request_Validation?.yes_no_response_code">
        <div class="main eligibility-container">
            <div class="d-flex justify-content-center mt-5">
                <button class="btn btn-primary btn-sm me-3" @click="downloadEligibility()">Print</button>
                <button class="btn btn-primary btn-sm" @click="cancel()">Close</button>
            </div>
            <div class="patient-container mb-3 p-3">
                <h4 class="mb-3">
                    {{ eligibilityData?.Subscriber?.first_name }}, {{ eligibilityData?.Subscriber?.last_name }}
                </h4>
                <p><strong> Date of Birth</strong> {{ eligibilityData?.Subscriber?.date }}</p>
                <p><strong> Medicare Number</strong> {{ eligibilityData?.Subscriber?.identification_code }}</p>
                <p><strong> Expiration Date:</strong> {{ eligibilityData?.Subscriber?.expiration_date }}</p>
                <p><strong> Gender</strong> {{ eligibilityData?.Subscriber?.gender }}</p>
            </div>
            <div class="medical mb-5 p-3">
                <h3 class="mb-3 fw-medium">Medicare Eligibility</h3>
                <div class="medicare-part medicare-container mb-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="sub-text">
                            <i class="fas fa-check-circle text-success me-1"></i>
                            Medicare Part A
                        </p>
                        <span class="sub-text">{{ eligibilityData?.Medicare_Part_A?.date }}</span>
                    </div>
                    <p>
                        This covers most medically necessary hospital, skilled nursing facility, home health and hospice
                        care.
                    </p>
                </div>
                <div class="medicare-part medicare-container">
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="sub-text">
                            <i class="fas fa-check-circle text-success me-1"></i>
                            Medicare Part B
                        </p>
                        <span class="sub-text">{{ eligibilityData?.Medicare_Part_B?.date }}</span>
                    </div>
                    <p>
                        This covers most medically necessary doctors' services, preventive care, durable medical
                        equipment, hospital outpatient services, laboratory tests, x-rays, mental health care, and some
                        home health and ambulance services.
                    </p>
                </div>

                <div class="medicare-part medicare-container-c mt-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="sub-text-part-c">
                            <i class="fa fa-info-circle me-1"></i>
                            Medicare Part C (Advantage Plans)
                        </p>
                    </div>
                    <p>
                        This allows private health insurance companies such as Health Maintenance Organizations (HMO)
                        and Preferred Provider Organizations (PPO)to provide Medicare benefits. These plans offer at
                        least the same benefits as original Medicare (those covered under Parts A and B) but can do so
                        with different rules, costs and coverage restrictions.
                    </p>
                    <div class="d-flex align-items-end flex-column current-date">
                        <p>Effective Date - Term Date</p>
                        <p>{{ eligibilityData?.MedicareAdvantages?.medicareAdvantagePayers[0]?.date }}</p>
                    </div>
                    <div class="d-flex gap-0 flex-column ms-2 ps-3 details">
                        <h4 class="current-date mb-0">
                            {{ eligibilityData?.MedicareAdvantages?.medicareAdvantagePayers[0]?.name }}
                        </h4>
                        <p class="mb-0">
                            {{ eligibilityData?.MedicareAdvantages?.medicareAdvantagePayers[0]?.insurance_type }}
                        </p>
                        <p class="mb-0">
                            <strong> Plan Number</strong>
                            {{ eligibilityData?.MedicareAdvantages?.medicareAdvantagePayers[0]?.reference_id }}
                        </p>
                        <p class="mb-0">
                            <strong> Address</strong>
                            {{ eligibilityData?.MedicareAdvantages?.medicareAdvantagePayers[0]?.address1 }}
                        </p>
                        <p>
                            <strong> Phone</strong>
                            {{ eligibilityData?.MedicareAdvantages?.medicareAdvantagePayers[0]?.phone }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" src="./verifyEligibility.scss"></style>
<script lang="ts" src="./verifyEligibility.ts"></script>
